import Link from 'next/link'
import FooterCardPopover from './FooterCardPopover'
import useI18n from 'Hooks/useI18n'
import { withLocale } from '@/locales'
import { getBeginnersGuidePdfUrl } from '@/constant/download'

export default function PaymentTerms() {
  const { t, lang } = useI18n()
  return (
    <div
      className="pointer-events-none fixed bottom-0 left-0 right-0"
      style={{
        background:
          'linear-gradient(180deg, rgba(30,21,29,0) 0%, rgba(30,21,29,0.96) 100%)',
      }}
    >
      <div className="mx-auto flex max-w-[3840px] select-none items-center justify-between pb-1.5 pl-[30px] pr-10 pt-[27px] text-xs leading-[13px]">
        <div className="pointer-events-auto flex items-center gap-5">
          <FooterCardPopover />
          <div className="h-2.5 w-px bg-white/50" />
          <div className="flex items-center gap-7">
            <Link
              href={withLocale('/privacy-policy', lang)}
              target="_blank"
              className="text-white/50 hover:text-white"
            >
              {t('Privacy Policy')}
            </Link>
            <Link
              href={withLocale('/terms-of-service', lang)}
              target="_blank"
              className="text-white/50 hover:text-white"
            >
              {t('Terms of Service')}
            </Link>
            <Link
              href={withLocale('/subscription/faq', lang)}
              target="_blank"
              className="text-white/50 hover:text-white"
            >
              {t('Subscription FAQ')}
            </Link>
            <Link
              href={withLocale('/community-guidelines', lang)}
              target="_blank"
              className="text-white/50 hover:text-white"
            >
              {t('Community Guidelines')}
            </Link>
            <Link
              href={getBeginnersGuidePdfUrl(lang)}
              target="_blank"
              className="text-white/50 hover:text-white"
            >
              {t("Beginner's Guide")}
            </Link>
            <Link
              href={withLocale('/about-us', lang)}
              target="_blank"
              className="text-white/50 hover:text-white"
            >
              {t('About Us')}
            </Link>
            <Link
              href={withLocale('/blog', lang)}
              target="_blank"
              className="text-white/50 hover:text-white"
            >
              {t('Blog')}
            </Link>
            {/*<Link*/}
            {/*  href={withLocale('/characters', lang)}*/}
            {/*  target="_blank"*/}
            {/*  className="text-white/50 hover:text-white"*/}
            {/*>*/}
            {/*  {t('Characters')}*/}
            {/*</Link>*/}
          </div>
        </div>
        <div className="ml-7 text-white/50">
          © {new Date().getFullYear()} LIGHTSPEED INTELLIGENCE PTE. LTD. All
          rights reserved.
        </div>
      </div>
    </div>
  )
}
